module.exports = {
    language: {
      name: 'Chinese'
    },
    home: {
      title:'Introduction',
      text:'The Jizhi Gene Database is a database system that integrates storage, management, query, and analysis functions. Based on genomic data, it can realize the one-click construction of various types of databases, including single genomic database, pangenomic database, multigenomic database, and species resource database.',
      text1:'Jizhi Gene Database aims to optimize the original data management mode, thereby improving the management and analysis capabilities of users on massive genomic data in the context of big data. The standard version database includes six modules: Home, Jbrowse, Browse, Analysis, Tools, and Download. It provides functions such as home page summary, visual browsing, data mining, analysis tools, and result download, respectively, to help users achieve the storage, management, and use of organizational data. On this basis, personalized functional modules can also be customized and developed according to the characteristics of various types of organizational data and user needs to achieve customized construction of the database.',
      Summary:'Summary',
      Features:'Features',
      Superiority:'Superiority',
      ContactUs:'Contact Us',
      ContactUs1:'Thank you for visiting the Jizhi Gene Genome Database! We can provide personalized database customization solutions based on your needs.',
      ContactUs2:'Contact us to customize the database for you.',
      phone:'Telephone',
      Email:'Email',
      Website:'Website',
      Address:'Address',
      Address1:'Floor 2, Building A9, International Enterprise Community, Wuqing Business District, Tianjin',
    },
    page:{
        Sumbit:'Sumbit',
        Reset:'Reset',
        Download:'Download',
        placeholder:'Please enter the content',
        Pathway:'Pathway',
        Introduction:'Introduction',
        RepeatMasker:'RepeatMasker',
        RepeatProteinMask:'RepeatProteinMask',
        SampleList:'SampleList',
        Correlation:'Correlation',
        Pvalue:'Pvalue',
        Genelist:'Genelist',
        ControlGroup:'Control Group',
        ExperimentGroup:'Experiment Group',
        padj:'padj',
        log2FoldChange:'log2FoldChange',
        Genome:'Genome',
        inputContent:'inputContent',
        Database:'Database',
        BlastType:'Blast Type',
        Input:'Input DNA or Protein Sequence',
        Expect:'Expect',
        Maxtargets:'Max targets',
        Type:'Type',
        GeneAnnotation:'Gene Annotation',
        GeneStructure:'Gene Structure',
        SequenceInformation:'Sequence Information',
    },
    title:{
        Result:'Result',
        tableResult:'Table Result',
        GeneCoExpression:'Gene Co-Expression',
        Deseq2:'Deseq2',
        KEGG:'KEGG Enrichment',
        GO:'GO Enrichment',
    }
  }